if (!customElements.get('vayndo-refill-upsell')) {
  customElements.define('vayndo-refill-upsell', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.form = this.querySelector('form');
      this.nativeForm = this.querySelector('product-form');
      this.selector = this.querySelector('[data-refill-select]');
      this.variantInput = this.querySelector('[data-refill-id]');
      this.quantityInput = this.querySelector('[data-refill-quantity]');
      this.button = this.querySelector('[type="submit"]');
      this.buttonLabel = this.querySelector('[data-refill-button-label]');
      this.price = this.querySelector('[data-refill-price]');
      this.image = this.querySelector('.vayndo-refill-upsell__image img');
      if (!this.form || !this.variantInput || !this.button) return;

      this.selector?.addEventListener('change', () => this.updateVariant(), { signal: this.abort.signal });
      this.addEventListener('submit', (event) => {
        if (event.target !== this.form) return;
        if (this.button.disabled || this.button.getAttribute('aria-disabled') === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, { capture: true, signal: this.abort.signal });
      if (this.selector) this.updateVariant();
    }

    disconnectedCallback() {
      this.abort?.abort();
    }

    updateVariant() {
      const option = this.selector?.options[this.selector.selectedIndex];
      if (!option) return;
      if (this.button.classList.contains('loading')) {
        this.selector.value = this.variantInput.value;
        return;
      }
      const available = option.dataset.canAdd === 'true';
      this.variantInput.value = option.value;
      this.quantityInput.value = option.dataset.quantity;
      this.price.textContent = option.dataset.price;
      this.button.disabled = !available;
      this.button.setAttribute('aria-disabled', String(!available));
      this.buttonLabel.textContent = available ? this.dataset.addLabel : this.dataset.unavailableLabel;
      const quantityNote = this.querySelector('[data-refill-quantity-note]');
      const quantityValue = this.querySelector('[data-refill-quantity-value]');
      if (quantityNote) quantityNote.hidden = Number(option.dataset.quantity) <= 1;
      if (quantityValue) quantityValue.textContent = option.dataset.quantity;
      if (this.image && option.dataset.image) {
        this.image.removeAttribute('srcset');
        this.image.src = option.dataset.image;
      }
      this.nativeForm.handleErrorMessage?.();
      this.nativeForm.error = false;
    }
  });
}
